import React, { SVGProps } from 'react';

export const CustomerIcon: React.FC<SVGProps<SVGSVGElement>> = ({
  width = 26,
  height = 26,
  fill = '#0063D6',
  ...props
}) => {
  return (
    <svg
      fill="none"
      height={height}
      viewBox="0 0 26 26"
      width={width}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M13 13C16.4719 13 19.2857 10.3141 19.2857 7C19.2857 3.68594 16.4719 1 13 1C9.52813 1 6.71429 3.68594 6.71429 7C6.71429 10.3141 9.52813 13 13 13ZM17.4 14.5H16.5799C15.4897 14.9781 14.2768 15.25 13 15.25C11.7232 15.25 10.5152 14.9781 9.42009 14.5H8.6C4.95625 14.5 2 17.3219 2 20.8V22.75C2 23.9922 3.0558 25 4.35714 25H21.6429C22.9442 25 24 23.9922 24 22.75V20.8C24 17.3219 21.0437 14.5 17.4 14.5Z"
        fill={fill}
      />
    </svg>
  );
};
